const { getLocalHour } = require("./datetimeUtils");


function xAxisFormatter(value) {
    if (value) {
        const date = new Date(value);
        return getLocalHour(date); // Formats to local date & time
    }
    return value;
}
module.exports = {    
    xAxisFormatter,        
}